import { useMemo } from "react";

import { PageTemplate } from "@/components/Templates/PageTemplate";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useScopeParams } from "@/hooks/useScopeParams";
import { FEATURE_FLAGS } from "@/utils/feature-flag-constants";
import { createSitesOverviewExtraTabs } from "./utils/extraTabs";

export type { SiteInfo } from "@/components/UI/SitesMap/types";

export default function SitesOverview() {
  const { scope, id } = useScopeParams();
  const metricsHidden = useFeatureFlag(
    FEATURE_FLAGS.SITES_OVERVIEW_METRICS_HIDDEN,
  );
  const profileHidden = useFeatureFlag(
    FEATURE_FLAGS.TRIAL_SITE_PROFILE_LINKS_HIDDEN,
  );
  const extraTabs = useMemo(
    () =>
      createSitesOverviewExtraTabs((flag) =>
        flag === FEATURE_FLAGS.SITES_OVERVIEW_METRICS_HIDDEN
          ? metricsHidden
          : false,
      ),
    [metricsHidden],
  );

  return (
    <PageTemplate
      title="Site Profiles"
      tooltipText="Explore site metrics across any level - from a single site, to sites in a country or region, to all of the sites in the study. View metrics, data, plots and a world map view of the geographic distribution of sites in the study."
      type="sites-overview"
      selectionIdentifierColumn="site"
      constants={{
        wikiLink: "/wiki/guides/exploration-sites-overview",
        idLink: profileHidden
          ? undefined
          : (siteId: string) =>
              `/${scope}/${id}/sites/profile/${siteId}/overview`,
      }}
      extraTabs={extraTabs}
    />
  );
}
